// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 视频详情 GET /promotion-video/info */
export async function promotionVideoInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.promotionVideoInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultPromotionVideoInfoResp>('/promotion-video/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 视频列表 GET /promotion-video/list */
export async function promotionVideoListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.promotionVideoListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListPromotionVideoListResp>('/promotion-video/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
